//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { blockInvalidChar } from "helpers/blockInvalidChar";


// custom pages
import Table from "components/Table/Table";
import promotion from "apis/promotion/promotion";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AuditAPI from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";
import toTitleCase from "helpers/convertTitleCase";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import searchIcon from "assets/img/Search_Icon.png";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import useDebounce from "helpers/useDebounce";
import Popover from '@material-ui/core/Popover';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';

// material-ui icons
import Grid from "@material-ui/core/Grid";
import { toastCss } from "assets/styleJS/global";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
//Helpers
import { dateFormat } from "helpers/dataFormat"
import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);


export default function Promotion(props) {
  const { state, dispatch } = useContext(context);
  const { getRules, executeProcedure, searchAPI, promotionFilterAPI, searchTypeAPI } = promotion();
  const { getAudit } = AuditAPI();

  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const { t, i18n } = useTranslation()
  const [isActive, setIsActive] = useState(true);
  const [isSignature, setIsSignature] = useState(true);
  const [filterCard, setFilterCard] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [type, setType] = useState([]);
  const [searchValue1, setSearchValue1] = useState("");
  const [response, setResponse] = useState({
    filter: false,
  });
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [selectedPromo, setSelectedPromo] = useState({
    promotionId: '',
    data: {}
  })

  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "Promotion Management"] });
  }, []);
  const searchBounceValues = useDebounce(searchValue);

  const [states, setstates] = useState({
    historyLoader: false,
    clearSearch: false,
    tier: [],
    reasonDescription: [],
    selectedtype: "",
    expired: "",
    sortBy: "ASC",
    orderBy: "start_date",
    reason: "",
    editObj: {},
    updateObj: {},
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  let sidemenuArr = state?.userInfo.loyalty_organization_name == "Henry Schein Dental" ||  "Henry Schein Canada" ? selectedPromo?.data?.criteriaRuleExist ?
    [
      { name: "View Details", path: "/dashboard/view-promotion" },
      { name: "Range", path: "/dashboard/range" },
      { name: "Criteria Rule", path: "/dashboard/criteria-rule" },
      { name: "Criteria", path: "/dashboard/criteria" },
      { name: "History", path: "" }
    ] : selectedPromo?.data?.rangeExist ?
      [
        { name: "View Details", path: "/dashboard/view-promotion" },
        { name: "Range", path: "/dashboard/range" },
        { name: "Criteria Rule", path: "/dashboard/criteria-rule" },
        { name: "History", path: "" }
      ] :
      [
        { name: "View Details", path: "/dashboard/view-promotion" },
        { name: "Range", path: "/dashboard/range" },
        { name: "History", path: "" }
      ] :
    [
      { name: "View Details", path: "/dashboard/view-promotion" },
      { name: "Range", path: "/dashboard/range" },
      { name: "Criteria", path: "/dashboard/criteria" },
      { name: "History", path: "" }
    ]

  const { historyLoader, clearSearch, tier, reasonDescription, editObj, updateObj } = states;

  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        orderBy: states.orderBy,
        sortBy: states.sortBy,
        isActive: isActive
      };
      if (states?.selectedtype) {
        values = { ...values, type: states?.selectedtype };
      }
      if (states?.expired == true || states?.expired == false) {
        values = { ...values, expired: states?.expired };
      }
      // if (typeof states.isActive === "boolean") {
      //   values = { ...values, isActive: states.isActive };
      // }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await promotionFilterAPI(values);
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        setData([])
        return false;
      }
      if (res.data.length > 0) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        setStates({ editObj: "" })
        dispatch({ type: "SET_LOADING", payload: false });
      }
      else {
        setFilterCard(false);
        setStates({
          editObj: ""
        })
      }
    }
    catch (e) {
      console.log({ e });
    }
  };



  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // handling api calls
  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      }
      else if (states.filter) {
        handleFilter()
      }
      else {
        handleGet();
        handleType()
      }
    }
    else {
      setStates({ clearSearch: false });
    }
  }, [offset, isActive, searchBounceValues]);

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
        isActive
      };
      let res = await getRules(values);
      if (res) {
        setData(res?.data);
        setCount(res?.count);
        setRes(true);
        dispatch({ type: 'SET_LOADING', payload: false })
      }
      // dispatch({ type: 'SET_LOADING', payload: false })      
    }
    catch (e) {
      console.log({ e });
      dispatch({ type: 'SET_LOADING', payload: false })
    }
  };

  // get api func
  const handleExcuteProcedure = async () => {
    try {
      let res = await executeProcedure();
      if (res) {
        toast.success("Executed successfully", {
          toastId: "execute-procedure",
        });
      }
    }
    catch (e) {
      console.log({ e });
    }
  };

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "pr",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    }
    catch (e) {
      console.log({ e });
    }
  };
  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
        isActive: isActive
      };
      setFilterCard(false);
      setResponse({ ...response, filter: false });
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    }
    catch (e) {
      console.log({ e });
    }
  }

  async function handleType() {
    try {
      setLoading(true);
      let values;
      values = {
        isActive: isActive,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchTypeAPI(values);
      if (res) {
        setType(res?.data)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    }
    catch (e) {
      console.log({ e });
    }
  }

  return (
    <React.Fragment>
      <Grid container className={classes.root}>

        {/* <Button
            className={`dash-1-filter-btn`}
            onClick={() => {
              handleExcuteProcedure();
            }}
          >
            Execute Procedure
          </Button> */}
        <div style={{ flex: 0.99 }}>
          <CssTextField
            placeholder="Search for Promotion Name or Promotion Description"
            type={"text"}
            variant="outlined"
            onKeyDown={blockInvalidCharForText}
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue("");
                        setOffset(1);
                        handleGet();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setOffset(1);
              if (e.target.value.length == 0) {
                handleGet();
              }
            }}
            onClick={() => {
              setOffset(offset);
            }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              handleType()
              setFilterCard(!filterCard);
              if (!states.filter) {
                setStates({
                  expired: "",
                  startDate: null,
                  endDate: null,
                  type: [],
                  reason: "",

                });
              }
            }}
          >
            {t('Filter')}
            {response["filter"] && (
              <Badge
                badgeContent={count == 0 ? null : response["filter"] && count}
                color="error"
                classes={{ badge: classes.badge }}
                max={999999}
                className={classes.badges}
              ></Badge>
            )}
          </Button>
        </div>
        <FormControl style={{ marginRight: 5 }}>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={true}
            name="radio-buttons-group"
            row
            value={isActive}
            onChange={(e) => {
              setIsActive(!isActive)
              setStates({
                filter: false,
                type: "",
                selectedtype: "",
                startDate: null,
                endDate: null,
                expired: "",
                reason: "",
                editObj: "",
                updateObj: ""
              });
              setOffset(1);
              setFilterCard(false);
              // handleGet();
              setCount(0);
              setResponse({ filter: false });
            }}
          >
            <FormControlLabel value={true} control={<Radio color="primary" />} label="Active" />
            <FormControlLabel value={false} control={<Radio color="primary" />} label="In-Active" />
          </RadioGroup>
        </FormControl>
        <Button
          className={`${classes.createBtn} dash-1-filter-btn`}
          onClick={() => {
            history.push("/dashboard/create-promotion");
          }}
        >
          Create
        </Button>
        <Grid xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
          {filterCard && (
            <div className={classes.filterCardDiv}>
              <Grid container spacing={0}>
                <Grid item xs={12} style={{ float: "right" }}>
                  <Card className={classes.filterCard}>
                    <Grid
                      container
                      spacing={2}
                      className={classes.filterCardGridContainer}
                    >
                      <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                        <div className={classes.filterCardHeadText}>Type</div>
                        <TextField
                          select
                          variant="outlined"
                          style={{ fontSize: "0.875rem !important", width: "100%" }}
                          type={"text"}
                          autoComplete="off"
                          value={states.selectedtype}
                          onChange={(e) => {
                            setStates({ selectedtype: e.target.value });
                          }}
                        >
                          {type?.length > 0 &&
                            type?.map((t) => (
                              <MenuItem value={t?.type}>
                                {toTitleCase(t?.type.replaceAll("_", " "))}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid item sm={3} xs={12} className={classes.filterCardGrid}
                      >
                        <div className={classes.filterCardHeadText}>Order By</div>

                        <TextField
                          select
                          variant="outlined"
                          style={{ fontSize: "0.875rem !important", width: "100%" }}
                          type={"text"}
                          autoComplete="off"
                          value={states.orderBy}
                          onChange={(e) => {
                            setStates({ orderBy: e.target.value });
                          }}
                        >
                          <MenuItem value={"start_date"}>Start Date</MenuItem>
                          <MenuItem value={"end_date"}>End Date</MenuItem>
                          {/* <MenuItem value={"extended_days"}>Extended Days</MenuItem> */}
                          <MenuItem value={"expire_date"}>Extended Date</MenuItem>




                        </TextField>
                      </Grid>
                      <Grid item sm={2} xs={12} className={classes.filterCardGrid}
                      >
                        <div className={classes.filterCardHeadText}>Sort</div>

                        <TextField
                          select
                          variant="outlined"
                          style={{ fontSize: "0.875rem !important", width: "100%" }}
                          type={"text"}
                          autoComplete="off"
                          value={states.sortBy}
                          onChange={(e) => {
                            setStates({ sortBy: e.target.value });
                          }}
                        >
                          <MenuItem value={"ASC"}>Asc</MenuItem>
                          <MenuItem value={"DESC"}>Desc</MenuItem>



                        </TextField>
                      </Grid>
                      {/* <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>Reason</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.reason}
                      onChange={(e) =>  {
                        if (e.target.value === "Others") {
                          setStates({
                            editObj: {
                              ...editObj,
                              tierReason: e.target.value,
                            },
                            updateObj: { ...updateObj, tierReason: "" },
                            reason: e.target.value
                          });
                        } else {
                          setStates({
                            editObj: {
                              ...editObj,
                              tierReason: e.target.value,
                            },
                            updateObj: { ...updateObj, tierReason: e.target.value },
                            reason: e.target.value
                          });
                        }
                      }}
                    > 
                     {reasonDescription?.length > 0 &&
                      reasonDescription?.map((t) => (
                        <MenuItem value={t?.reason_description}>
                          {t?.reason_description}
                        </MenuItem>
                      ))}
                     
                      
                    </TextField>
                  </Grid> */}
                      <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                        <div className={classes.filterCardHeadText}>Expired</div>
                        <TextField
                          select
                          variant="outlined"
                          style={{ fontSize: "0.875rem !important", width: "100%" }}
                          type={"text"}
                          autoComplete="off"
                          value={states.expired}
                          onChange={(e) => {
                            setStates({ expired: e.target.value });
                          }}
                        >
                          <MenuItem value={true}>{t('Yes')}</MenuItem>
                          <MenuItem value={false}>{t('No')}</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item sm={2} xs={12} className={classes.filterCardBtnGrid}                      >
                        <Grid container spacing={0}>
                          <Grid item xs={12}>
                            <Button
                              className={classes.filterCardApplyBtn}
                              onClick={() => {
                                if (
                                  !states?.reason &&
                                  !states?.type &&
                                  !states?.expired &&
                                  !states.startDate &&
                                  !states.endDate
                                ) {
                                  toast.error("Please select atleast one field.");
                                  return;
                                }
                                if (!states.redemptionTo && states.redemptionFrom) {
                                  toast.error("Please select To column");
                                  return;
                                }
                                if (states.redemptionTo && !states.redemptionFrom) {
                                  toast.error("Please select From column");
                                  return;
                                }
                                handleFilter();
                                setCount(0);
                                setOffset(1);
                                setResponse({ filter: false });
                              }}
                            >
                              {t('Apply')}
                            </Button>
                          </Grid>
                          {states.filter && (
                            <Grid item xs={12}>
                              <Button
                                className={classes.filterCardResetBtn}
                                onClick={() => {
                                  setStates({
                                    filter: false,
                                    type: "",
                                    startDate: null,
                                    selectedtype: "",
                                    endDate: null,
                                    expired: "",
                                    reason: "",
                                    editObj: "",
                                    updateObj: ""
                                  });
                                  setOffset(1);
                                  setFilterCard(false);
                                  handleGet();
                                  setCount(0);
                                  setResponse({ filter: false });
                                }}
                              >
                                {t('Reset')}
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )}
        </Grid>
      </Grid>

      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid xs={12} sm={12} lg={12}>
            {res ? (
              <Table
                headings={[
                  "Promotion Name",
                  "Promotion Description",
                  "Start Date",
                  "End Date",
                  "Extended Date",
                  "Type",
                  "Frequency",
                  "",
                  ""
                ]}
                data={
                  data.map((d, i) => [
                    d?.promotion_name,
                    d?.promotion_description,
                    d?.start_date
                      ? dateFormat(d?.start_date, i18n.language)
                      : "-",
                    d?.end_date ? dateFormat(d?.end_date, i18n.language) : "-",
                    d?.expire_date
                      ? dateFormat(d?.expire_date, i18n.language)
                      : "-",
                    d?.type,
                    d?.frequency,
                    <div
                      style={{ cursor: "pointer" }}
                      aria-describedby={d.promotion_id}
                    >
                      <VisibilityIcon onClick={e => {
                        setAnchorEl(e.currentTarget);
                        setSelectedPromo({ promotionId: d.promotion_id, data: d })
                      }} />
                    </div>,
                  ])
                }
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            ) : (
              <Loader Loading={true} top={"15%"} />
            )}
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              {sidemenuArr.map(item => {
                return <List>
                  <ListItem
                    className={classes.listItem}
                    onClick={e => {
                      if (item.name == "History") {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(selectedPromo?.promotionId);
                        return;
                      }
                      history.push(item.path, { id: selectedPromo?.promotionId, data: selectedPromo?.data })
                    }}>
                    {item.name}
                  </ListItem>
                </List>
              })}
            </Popover>
          </Grid>
        </Grid>
      </Loader>
      {/* history */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
